import React, { useState } from 'react'
import * as routeLink from "../../constants/routeLink";

import TopInfo from "../../components/TopInfo/index";
import BalanceInfo from "../../components/BalanceInfo/index";
import CardTask from "../../components/CardTask/index";
import TopLevel from "../../components/TopLevel/index";
import Modal from "../../components/Modal/index";
import { useNavigate } from 'react-router-dom';
import { claimMs } from '../../services/services';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';
const Index = (props) => {
  const { apiReducer } = useSelector((state) => state);
  const { user } = apiReducer;

  const navigate = useNavigate();
  const onclickChangePage = (path) => {
    navigate(path);
  }

  const [modal1, setModal1] = useState(null);
  const [modal2, setModal2] = useState(null);
  const [modal3, setModal3] = useState(null);
  const [modal4, setModal4] = useState(null);
  const [modal5, setModal5] = useState(null);
  const [modal6, setModal6] = useState(null);
  const [modal7, setModal7] = useState(null);
  const [modal8, setModal8] = useState(null);

  const claim_ms = async (ty) => {

    // setIsLoading(true);
    const res = await claimMs(ty);
    if (res?.message) {
      toast(res.message)
    }
    setModal1(false)
    setModal2(false)
    setModal3(false)
    setModal4(false)
    setModal5(false)
    setModal6(false)
    setModal7(false)
    setModal8(false)
    // setIsLoading(false);
    // setModal2(false);
  }
  return (
    <div className='d-flex justify-content-center align-items-center flex-column'>


      <TopInfo />
      <TopLevel />
      <div className='w-100 d-flex justify-content-center align-items-center flex-column p-2'>
        <div className='card-custom w-100 p-3 radius-custom d-flex flex-column justify-content-center align-items-center'>
          <div className='d-flex justify-content-center align-items-center'>
            <h4 className='text-white fs-extra d-flex m-0 mx-2'>4 TASK</h4>
          </div>
        </div>
      </div>

      {/* <div className='w-100 d-flex justify-content-center align-items-start flex-column p-2'>
        <h4 className='text-white d-flex m-0 mb-1'>Daily rewards</h4>


        <CardTask item={{ title: "Daily rewards", price: "30" }} actions={() => onclickChangePage(routeLink.DAILY_REWARD)} />

      </div> */}
      <div className='w-100 d-flex justify-content-center align-items-start flex-column p-2'>
        <h4 className='text-white d-flex m-0 mb-1'>Task list</h4>


        <CardTask item={{ title: "Join our telegram chanel", url: 'https://t.me/dogxontoncommunity', price: "100" }} actions={() => setModal2(true)} />
        <CardTask item={{ title: "Flow our X account", url: 'https://x.com/dogxonton', price: "100" }} actions={() => setModal1(true)} />
        <CardTask item={{ title: "Follow GrandJourney Channel", url: 'https://t.me/Channel_GrandJourney', price: "100" }} actions={() => setModal3(true)} />
        <CardTask item={{ title: "Join GrandJourney Dapp", url: 'https://t.me/grandjourneybot/airdrop?startapp=ref_aRql1Z', price: "100" }} actions={() => setModal4(true)} />
        <CardTask item={{ title: "Follow Purr X channel", url: 'https://x.com/purrfund', price: "100" }} actions={() => setModal5(true)} />
        <CardTask item={{ title: "Follow Purr Telegram channel", url: 'https://t.me/purr_news', price: "100" }} actions={() => setModal6(true)} />
        <CardTask item={{ title: "Join Purr Dapp", url: 'https://t.me/purr_fund_bot', price: "100" }} actions={() => setModal7(true)} />
        <CardTask item={{ title: "Join Booms", url: 'https://t.me/booms_io_bot/start?startapp=bro209713032', price: "100" }} actions={() => setModal8(true)} />

      </div>

      <Modal setHide={setModal1} show={modal1}>
        <div className='w-75 d-flex justify-content-center align-items-center flex-column p-2 m-0 m-auto'>
          <div className='card-icon me-2' style={{ width: "80px", height: "80px" }}>
            <img className='w-100 h-100 object-fit-contain' src={`${routeLink.domain}/assets/imgs/footprintDog.png`} />
          </div>

          <h4 className='text-white text-center fs-extra d-flex m-0 mb-3'>Flow our X Account</h4>

          <a style={{ textAlign: 'center' }} href='https://x.com/dogxonton' target='_black' className='bg-unset border-unset scale_btn btn-custom-outline p-2 w-50 mb-3'>
            <span className='text-white'>Join</span>
          </a>
          <div className='d-flex justify-content-center align-items-start flex-column mb-3'>
            <div className='d-flex w-100 justify-content-center align-items-center'>
              <div className='card-icon me-2 bg-white radius-custom-8' style={{ width: "30px", height: "30px" }} >
                <img className='w-100 h-100' src={`${routeLink.domain}/assets/imgs/footprintDog.png`} />
              </div>
              <span className='fw-bold fs-extra text-white'>{"100"}</span>
            </div>
          </div>


        </div>
        <button onClick={() => { claim_ms(1) }} disabled={user?.mission?.['ms1']} className='d-flex w-100 justify-content-center align-items-center  scale_btn btn btn-custom-2' style={{ height: "30px", minHeight: "unset" }}>
          <span className='text-white fw-bold'>Claim</span>
        </button>
      </Modal>


      <Modal setHide={setModal2} show={modal2}>
        <div className='w-75 d-flex justify-content-center align-items-center flex-column p-2 m-0 m-auto'>
          <div className='card-icon me-2' style={{ width: "80px", height: "80px" }}>
            <img className='w-100 h-100 object-fit-contain' src={`${routeLink.domain}/assets/imgs/footprintDog.png`} />
          </div>

          <h4 className='text-white text-center fs-extra d-flex m-0 mb-3'>Join Our Telegram Chanel</h4>

          {/* <button className='bg-unset border-unset scale_btn btn-custom-outline p-2 w-50 mb-3'>
            <span className='text-white'>Join</span>
          </button> */}
          <a style={{ textAlign: 'center' }} href='https://t.me/dogxontoncommunity' target='_black' className='bg-unset border-unset scale_btn btn-custom-outline p-2 w-50 mb-3'>
            <span className='text-white'>Join</span>
          </a>
          <div className='d-flex justify-content-center align-items-start flex-column mb-3'>
            <div className='d-flex w-100 justify-content-center align-items-center'>
              <div className='card-icon me-2 bg-white radius-custom-8' style={{ width: "30px", height: "30px" }} >
                <img className='w-100 h-100' src={`${routeLink.domain}/assets/imgs/footprintDog.png`} />
              </div>
              <span className='fw-bold fs-extra text-white'>{"100"}</span>
            </div>
          </div>


        </div>
        <button onClick={() => { claim_ms(2) }} disabled={user?.mission?.['ms2']} className='d-flex w-100 justify-content-center align-items-center  scale_btn btn btn-custom-2' style={{ height: "30px", minHeight: "unset" }}>
          <span className='text-white fw-bold'>Claim</span>
        </button>
      </Modal>

      <Modal setHide={setModal3} show={modal3}>
        <div className='w-75 d-flex justify-content-center align-items-center flex-column p-2 m-0 m-auto'>
          <div className='card-icon me-2' style={{ width: "80px", height: "80px" }}>
            <img className='w-100 h-100 object-fit-contain' src={`${routeLink.domain}/assets/imgs/footprintDog.png`} />
          </div>

          <h4 className='text-white text-center fs-extra d-flex m-0 mb-3'>Follow Channel</h4>

          {/* <button className='bg-unset border-unset scale_btn btn-custom-outline p-2 w-50 mb-3'>
            <span className='text-white'>Join</span>
          </button> */}
          <a style={{ textAlign: 'center' }} href='https://t.me/Channel_GrandJourney' target='_black' className='bg-unset border-unset scale_btn btn-custom-outline p-2 w-50 mb-3'>
            <span className='text-white'>Join</span>
          </a>
          <div className='d-flex justify-content-center align-items-start flex-column mb-3'>
            <div className='d-flex w-100 justify-content-center align-items-center'>
              <div className='card-icon me-2 bg-white radius-custom-8' style={{ width: "30px", height: "30px" }} >
                <img className='w-100 h-100' src={`${routeLink.domain}/assets/imgs/footprintDog.png`} />
              </div>
              <span className='fw-bold fs-extra text-white'>{"100"}</span>
            </div>
          </div>


        </div>
        <button onClick={() => { claim_ms(3) }} disabled={user?.mission?.['ms3']} className='d-flex w-100 justify-content-center align-items-center  scale_btn btn btn-custom-2' style={{ height: "30px", minHeight: "unset" }}>
          <span className='text-white fw-bold'>Claim</span>
        </button>
      </Modal>

      <Modal setHide={setModal4} show={modal4}>
        <div className='w-75 d-flex justify-content-center align-items-center flex-column p-2 m-0 m-auto'>
          <div className='card-icon me-2' style={{ width: "80px", height: "80px" }}>
            <img className='w-100 h-100 object-fit-contain' src={`${routeLink.domain}/assets/imgs/footprintDog.png`} />
          </div>

          <h4 className='text-white text-center fs-extra d-flex m-0 mb-3'>Join dApp</h4>

          {/* <button className='bg-unset border-unset scale_btn btn-custom-outline p-2 w-50 mb-3'>
            <span className='text-white'>Join</span>
          </button> */}
          <a style={{ textAlign: 'center' }} href='https://t.me/grandjourneybot/airdrop?startapp=ref_aRql1Z' target='_black' className='bg-unset border-unset scale_btn btn-custom-outline p-2 w-50 mb-3'>
            <span className='text-white'>Join</span>
          </a>
          <div className='d-flex justify-content-center align-items-start flex-column mb-3'>
            <div className='d-flex w-100 justify-content-center align-items-center'>
              <div className='card-icon me-2 bg-white radius-custom-8' style={{ width: "30px", height: "30px" }} >
                <img className='w-100 h-100' src={`${routeLink.domain}/assets/imgs/footprintDog.png`} />
              </div>
              <span className='fw-bold fs-extra text-white'>{"100"}</span>
            </div>
          </div>


        </div>
        <button onClick={() => { claim_ms(4) }} disabled={user?.mission?.['ms4']} className='d-flex w-100 justify-content-center align-items-center  scale_btn btn btn-custom-2' style={{ height: "30px", minHeight: "unset" }}>
          <span className='text-white fw-bold'>Claim</span>
        </button>
      </Modal>

      <Modal setHide={setModal5} show={modal5}>
        <div className='w-75 d-flex justify-content-center align-items-center flex-column p-2 m-0 m-auto'>
          <div className='card-icon me-2' style={{ width: "80px", height: "80px" }}>
            <img className='w-100 h-100 object-fit-contain' src={`${routeLink.domain}/assets/imgs/footprintDog.png`} />
          </div>

          <h4 className='text-white text-center fs-extra d-flex m-0 mb-3'>Follow Purr X channel</h4>

          {/* <button className='bg-unset border-unset scale_btn btn-custom-outline p-2 w-50 mb-3'>
            <span className='text-white'>Join</span>
          </button> */}
          <a style={{ textAlign: 'center' }} href='https://x.com/purrfund' target='_black' className='bg-unset border-unset scale_btn btn-custom-outline p-2 w-50 mb-3'>
            <span className='text-white'>Join</span>
          </a>
          <div className='d-flex justify-content-center align-items-start flex-column mb-3'>
            <div className='d-flex w-100 justify-content-center align-items-center'>
              <div className='card-icon me-2 bg-white radius-custom-8' style={{ width: "30px", height: "30px" }} >
                <img className='w-100 h-100' src={`${routeLink.domain}/assets/imgs/footprintDog.png`} />
              </div>
              <span className='fw-bold fs-extra text-white'>{"100"}</span>
            </div>
          </div>


        </div>
        <button onClick={() => { claim_ms(5) }} disabled={user?.mission?.['ms5']} className='d-flex w-100 justify-content-center align-items-center  scale_btn btn btn-custom-2' style={{ height: "30px", minHeight: "unset" }}>
          <span className='text-white fw-bold'>Claim</span>
        </button>
      </Modal>

      <Modal setHide={setModal6} show={modal6}>
        <div className='w-75 d-flex justify-content-center align-items-center flex-column p-2 m-0 m-auto'>
          <div className='card-icon me-2' style={{ width: "80px", height: "80px" }}>
            <img className='w-100 h-100 object-fit-contain' src={`${routeLink.domain}/assets/imgs/footprintDog.png`} />
          </div>

          <h4 className='text-white text-center fs-extra d-flex m-0 mb-3'>Follow Purr Telegram channel</h4>

          {/* <button className='bg-unset border-unset scale_btn btn-custom-outline p-2 w-50 mb-3'>
            <span className='text-white'>Join</span>
          </button> */}
          <a style={{ textAlign: 'center' }} href='https://t.me/purr_news' target='_black' className='bg-unset border-unset scale_btn btn-custom-outline p-2 w-50 mb-3'>
            <span className='text-white'>Join</span>
          </a>
          <div className='d-flex justify-content-center align-items-start flex-column mb-3'>
            <div className='d-flex w-100 justify-content-center align-items-center'>
              <div className='card-icon me-2 bg-white radius-custom-8' style={{ width: "30px", height: "30px" }} >
                <img className='w-100 h-100' src={`${routeLink.domain}/assets/imgs/footprintDog.png`} />
              </div>
              <span className='fw-bold fs-extra text-white'>{"100"}</span>
            </div>
          </div>


        </div>
        <button onClick={() => { claim_ms(6) }} disabled={user?.mission?.['ms6']} className='d-flex w-100 justify-content-center align-items-center  scale_btn btn btn-custom-2' style={{ height: "30px", minHeight: "unset" }}>
          <span className='text-white fw-bold'>Claim</span>
        </button>
      </Modal>

      <Modal setHide={setModal7} show={modal7}>
        <div className='w-75 d-flex justify-content-center align-items-center flex-column p-2 m-0 m-auto'>
          <div className='card-icon me-2' style={{ width: "80px", height: "80px" }}>
            <img className='w-100 h-100 object-fit-contain' src={`${routeLink.domain}/assets/imgs/footprintDog.png`} />
          </div>

          <h4 className='text-white text-center fs-extra d-flex m-0 mb-3'>Join Purr Dapp</h4>

          {/* <button className='bg-unset border-unset scale_btn btn-custom-outline p-2 w-50 mb-3'>
            <span className='text-white'>Join</span>
          </button> */}
          <a style={{ textAlign: 'center' }} href='https://t.me/purr_fund_bot' target='_black' className='bg-unset border-unset scale_btn btn-custom-outline p-2 w-50 mb-3'>
            <span className='text-white'>Join</span>
          </a>
          <div className='d-flex justify-content-center align-items-start flex-column mb-3'>
            <div className='d-flex w-100 justify-content-center align-items-center'>
              <div className='card-icon me-2 bg-white radius-custom-8' style={{ width: "30px", height: "30px" }} >
                <img className='w-100 h-100' src={`${routeLink.domain}/assets/imgs/footprintDog.png`} />
              </div>
              <span className='fw-bold fs-extra text-white'>{"100"}</span>
            </div>
          </div>


        </div>
        <button onClick={() => { claim_ms(7) }} disabled={user?.mission?.['ms7']} className='d-flex w-100 justify-content-center align-items-center  scale_btn btn btn-custom-2' style={{ height: "30px", minHeight: "unset" }}>
          <span className='text-white fw-bold'>Claim</span>
        </button>
      </Modal>

      <Modal setHide={setModal8} show={modal8}>
        <div className='w-75 d-flex justify-content-center align-items-center flex-column p-2 m-0 m-auto'>
          <div className='card-icon me-2' style={{ width: "80px", height: "80px" }}>
            <img className='w-100 h-100 object-fit-contain' src={`${routeLink.domain}/assets/imgs/footprintDog.png`} />
          </div>

          <h4 className='text-white text-center fs-extra d-flex m-0 mb-3'>Join Booms</h4>

          {/* <button className='bg-unset border-unset scale_btn btn-custom-outline p-2 w-50 mb-3'>
            <span className='text-white'>Join</span>
          </button> */}
          <a style={{ textAlign: 'center' }} href='https://t.me/booms_io_bot/start?startapp=bro209713032' target='_black' className='bg-unset border-unset scale_btn btn-custom-outline p-2 w-50 mb-3'>
            <span className='text-white'>Join</span>
          </a>
          <div className='d-flex justify-content-center align-items-start flex-column mb-3'>
            <div className='d-flex w-100 justify-content-center align-items-center'>
              <div className='card-icon me-2 bg-white radius-custom-8' style={{ width: "30px", height: "30px" }} >
                <img className='w-100 h-100' src={`${routeLink.domain}/assets/imgs/footprintDog.png`} />
              </div>
              <span className='fw-bold fs-extra text-white'>{"100"}</span>
            </div>
          </div>


        </div>
        <button onClick={() => { claim_ms(8) }} disabled={user?.mission?.['ms8']} className='d-flex w-100 justify-content-center align-items-center  scale_btn btn btn-custom-2' style={{ height: "30px", minHeight: "unset" }}>
          <span className='text-white fw-bold'>Claim</span>
        </button>
      </Modal>
    </div>
  )
}

export default Index;
